import React from "react";
import "./MemberStatusChanger.css";
import MemberStatusButton from "./MemberStatusButton/MemberStatusButton";
import popupicon from "../../../assets/icons/popupicon.svg";
import { UserAuth } from "../../../context/AuthContext";
import strings from "../../../locales/ro.json"
import StandardPopup from "../../Global/StandardPopup/StandardPopup";

import { useUI } from "../../../hooks/usePermission";
import { useApi } from "../../../hooks/useApi";

/*

  This component is the pressable button to change a member's status. It opens up three identical buttons in a container when pressed in order to change status

  Props

  status : a member's status {"junior","senior","alumni"}. Default is !Error!

*/

function MemberStatusChanger({ status, name , userUid}) {
  const [memberStatus, setMemberStatus] = React.useState(status); // we initialise this to the member status. this is using state so we can see it change without refreshing the page
  const [isChanging, setIsChanging] = React.useState(false); // this is so we open the other three buttons
  const [popupOpen, setPopupOpen] = React.useState(false);
  const [popupFunction, setPopupFunction] = React.useState(() => {});
  const [nextStatute, setNextStatute] = React.useState("Something has gone wrong!"); // this is used when changing status, so we can show it in the popup
  const {user} = UserAuth();
  const canManageStatus = useUI("action.users.manage");


  // this closes the small popup when we click outside of it
  const handleClickOutsideMemberStatus = (event) => {
    if (!event.target.closest('.memberStatusButtonContainer')) {
      setIsChanging((prevIsChanging) => false);
    }
  };

  function toggleChanging() {
    if (canManageStatus) {
      setIsChanging((prevIsChanging) => !prevIsChanging);
    }
  }
  const { api } = useApi();

  //send request to backend
  async function setStatuteInBackend(newStatute) {
    try {
      const result = await api(`users/${userUid}`, "GET");
      let changed = false;
      result.groups.forEach((element, index) => {
        if(element == strings.basicUserGroups.juniors || element == strings.basicUserGroups.seniors || element == strings.basicUserGroups.alumni || element == strings.basicUserGroups.friends || element == strings.basicUserGroups.freezed) {
          result.groups[index] = newStatute
          changed = true;
        }
      });

      if(!changed) {
        result.groups.push(newStatute)
      }
      let groups = result.groups
      await api(`users/${userUid}`, "PATCH", {groups});
    } catch (error) {
      console.error(error);
    }
  }

  // for popup
  let option = `${name} ${status} -> ${nextStatute} `

  // this is for sorting by statute
  React.useEffect(() => { 
    setMemberStatus(status);
  }, [status]);

  // to unload on lose focus
  React.useEffect(() => {
      document.addEventListener('click', handleClickOutsideMemberStatus);
      return () => {
          document.removeEventListener('click', handleClickOutsideMemberStatus);
      };
  }, []);

  const statutes = [
    { key: "junior", group: strings.basicUserGroups.juniors },
    { key: "senior", group: strings.basicUserGroups.seniors },
    { key: "alumni", group: strings.basicUserGroups.alumni },
    { key: "friend", group: strings.basicUserGroups.friends },
    { key: "freezed", group: strings.basicUserGroups.freezed },
  ];

  return (
    <div>
      <StandardPopup isOpen={popupOpen} icon={popupicon} message={strings.usermanagement.changePopup} message2={option} yesFcn={popupFunction} noFcn={() => {setIsChanging(false);setPopupOpen(false)}}/>
      <div className="memberStatusButtonContainer">
        <MemberStatusButton
          status={memberStatus}
          onClickFunction={toggleChanging}
          isAdmin={canManageStatus}
        />
        {canManageStatus && isChanging && (
          <div className="memberStatusButtonChangeContainer" data-testid='memberStatusButtonsContainer'>
            {statutes.map(({ key, group }) => (
              <MemberStatusButton
                key={key}
                status={key}
                onClickFunction={() => {
                  setPopupFunction(() => {
                    return () => {
                      setMemberStatus(key);
                      setStatuteInBackend(group);
                      setIsChanging(false);
                      setPopupOpen(false);
                    };
                  });
                  setNextStatute(key);
                  setPopupOpen(true);
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MemberStatusChanger;
